import { Component, Input } from '@angular/core';
import {
  Announcement,
  AnnouncementStep,
  categoryLabel,
  defaultButtonText,
  formatAnnouncementDate,
  isBlank,
  toParagraphs
} from '../whats-new';

@Component({
  selector: 'app-whats-new-preview',
  templateUrl: './whats-new-preview.component.html',
  styleUrls: ['./whats-new-preview.component.css']
})
export class WhatsNewPreviewComponent {
  @Input() announcement: Announcement;
  @Input() mode: 'list' | 'detail' = 'detail';

  public paragraphsOf = toParagraphs;

  get categoryLabel(): string {
    return categoryLabel(this.announcement.category);
  }

  get date(): string {
    return formatAnnouncementDate(this.announcement.publishDate);
  }

  get steps(): AnnouncementStep[] {
    return (this.announcement.steps || []).filter(step => !isBlank(step.text) || !isBlank(step.imageUrl));
  }

  get buttonText(): string {
    if (isBlank(this.announcement.targetPath)) {
      return '';
    }
    return isBlank(this.announcement.targetButtonText)
      ? defaultButtonText(this.announcement.targetPath)
      : this.announcement.targetButtonText;
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/whats-new/whats-new-preview/whats-new-preview.component.ts